import React from 'react';
import { Inbox, AlertTriangle } from 'lucide-react';

export function Loading({ label = 'Načítám…' }) {
  return (
    <div className="loading" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function Empty({ title, children }) {
  return (
    <div className="empty">
      <Inbox size={26} aria-hidden="true" style={{ marginBottom: '.5rem', opacity: .6 }} />
      <h3>{title}</h3>
      {children && <p>{children}</p>}
    </div>
  );
}

export function ErrorNotice({ children, tone = 'danger' }) {
  return (
    <div className={`notice notice-${tone}`} role="alert">
      <AlertTriangle size={18} aria-hidden="true" />
      <div>{children}</div>
    </div>
  );
}
